module.exports = __webpack_public_path__ + "img/checked-box.3e953902.svg";